import { useCallback } from 'react';
import { useDeckStore } from '../stores/deck-store.js';
import { api, ApiClientError } from '../lib/api-client.js';

export function useTagProfile() {
  const entries = useDeckStore((s) => s.entries);
  const setTagProfile = useDeckStore((s) => s.setTagProfile);
  const setProfileLoading = useDeckStore((s) => s.setProfileLoading);

  const analyze = useCallback(async (force = false) => {
    const names = entries.map((e) => e.card.name);
    if (names.length === 0) return;

    setProfileLoading(true);
    try {
      const response = await api.profileDeck(names, force);
      setTagProfile(response.profile, response.hierarchy);
    } catch (err) {
      const message =
        err instanceof ApiClientError ? err.message : 'Failed to analyze deck. Try again.';
      console.error('[useTagProfile]', message);
    } finally {
      setProfileLoading(false);
    }
  }, [entries, setTagProfile, setProfileLoading]);

  return { analyze };
}
